module.exports = __webpack_public_path__ + "img/outer.b838e0b9.png";